import type { Filters } from '../types/biApp';

export function buildParams(filters: Filters, limit: number) {
    const params = new URLSearchParams({
        date_from: filters.dateFrom,
        date_to: filters.dateTo,
        limit: String(limit),
        page: String(filters.page),
        sort: 'statement_date',
        direction: 'desc',
    });
    if (filters.companyIds.length > 0) {
        params.set('company_ids', filters.companyIds.join(','));
    }
    if (filters.accountId) {
        params.set('account_id', filters.accountId);
    }
    return params;
}

export function quickFilter(filter: string): Partial<Filters> {
    const today = new Date();
    today.setHours(12, 0, 0, 0);
    const iso = (date: Date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };
    const monthStart = (year: number, month: number) => new Date(year, month, 1, 12, 0, 0, 0);
    const monthEnd = (year: number, month: number) => new Date(year, month + 1, 0, 12, 0, 0, 0);
    const quarterBounds = (year: number, quarterIndex: number) => {
        const startMonth = quarterIndex * 3;
        return {
            from: monthStart(year, startMonth),
            to: monthEnd(year, startMonth + 2),
        };
    };
    const year = today.getFullYear();
    const month = today.getMonth();
    const quarter = Math.floor(month / 3);

    if (filter === '7 dana') {
        const start = new Date(today);
        start.setDate(today.getDate() - 6);
        return { dateFrom: iso(start), dateTo: iso(today) };
    }
    if (filter === 'prošli tjedan') {
        const day = today.getDay(); // 0=Sun, 1=Mon...
        const offsetFromMonday = (day + 6) % 7;
        const thisMonday = new Date(today);
        thisMonday.setDate(today.getDate() - offsetFromMonday);
        const prevMonday = new Date(thisMonday);
        prevMonday.setDate(thisMonday.getDate() - 7);
        const prevSunday = new Date(prevMonday);
        prevSunday.setDate(prevMonday.getDate() + 6);

        return { dateFrom: iso(prevMonday), dateTo: iso(prevSunday) };
    }
    if (filter === 'ovaj mjesec') {
        return { dateFrom: iso(monthStart(year, month)), dateTo: iso(monthEnd(year, month)) };
    }
    if (filter === 'prošli mjesec') {
        const prevMonth = month === 0 ? 11 : month - 1;
        const prevMonthYear = month === 0 ? year - 1 : year;
        return { dateFrom: iso(monthStart(prevMonthYear, prevMonth)), dateTo: iso(monthEnd(prevMonthYear, prevMonth)) };
    }
    if (filter === 'ovaj kvartal') {
        const bounds = quarterBounds(year, quarter);
        return { dateFrom: iso(bounds.from), dateTo: iso(bounds.to) };
    }
    if (filter === 'prošli kvartal') {
        const prevQuarter = quarter === 0 ? 3 : quarter - 1;
        const prevQuarterYear = quarter === 0 ? year - 1 : year;
        const bounds = quarterBounds(prevQuarterYear, prevQuarter);
        return { dateFrom: iso(bounds.from), dateTo: iso(bounds.to) };
    }
    if (filter === 'ova godina') {
        return { dateFrom: `${year}-01-01`, dateTo: `${year}-12-31` };
    }
    if (filter === 'prošla godina') {
        const prevYear = year - 1;
        return { dateFrom: `${prevYear}-01-01`, dateTo: `${prevYear}-12-31` };
    }
    return {};
}
